import React, { useMemo } from "react";
import { FiInfo } from "react-icons/fi";
import Container from "../Container";
import ContainerItem from "../Container/ContainerItem";
import { APPROVAL_ACCESS_NOTICE_PRESETS } from "./presets";
import "./style.scss";

const PRESET_MAP = {
  ...APPROVAL_ACCESS_NOTICE_PRESETS,
};

/**
 * Formal empty / access notice (card + icon + steps).
 * Use `preset` for built-in copy or pass title, lead, steps, etc. directly.
 */
const AccessNotice = ({
  preset,
  icon,
  title,
  lead,
  steps,
  panelTitle = "Yapılması gerekenler",
  footer,
  className = "",
  wrapped = true,
}) => {
  const content = useMemo(() => {
    const base = preset ? PRESET_MAP[preset] || {} : {};
    return {
      icon: icon ?? base.icon ?? FiInfo,
      title: title ?? base.title ?? "",
      lead: lead ?? base.lead ?? "",
      steps: steps ?? base.steps ?? [],
      footer: footer ?? base.footer ?? "",
    };
  }, [preset, icon, title, lead, steps, footer]);

  const Icon = content.icon;

  const body = (
    <div className={`card shadow-sm access-notice ${className}`.trim()}>
      <div className="card-body">
        <div className="access-notice__inner">
          <div className="access-notice__icon" aria-hidden>
            <Icon />
          </div>
          {content.title ? (
            <h2 className="access-notice__title">{content.title}</h2>
          ) : null}
          {content.lead ? (
            <p className="access-notice__lead">{content.lead}</p>
          ) : null}
          {content.steps?.length > 0 ? (
            <div className="access-notice__panel">
              <p className="access-notice__panel-title">{panelTitle}</p>
              <ol className="access-notice__steps">
                {content.steps.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            </div>
          ) : null}
          {content.footer ? (
            <p className="access-notice__footer">{content.footer}</p>
          ) : null}
        </div>
      </div>
    </div>
  );

  if (!wrapped) return body;

  return (
    <Container>
      <ContainerItem>{body}</ContainerItem>
    </Container>
  );
};

export default AccessNotice;
export { APPROVAL_ACCESS_NOTICE_PRESETS };
